import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { BehaviorSubject, ReplaySubject } from 'rxjs';
import { Currency } from './services/api/api.service';
import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from '@app/environment.service';
import { CookieService } from 'ngx-cookie-service';
import {
  getLocaleCurrencyCode,
  getLocaleCurrencyName,
  getLocaleCurrencySymbol,
} from '@angular/common';
import { currencies } from './currencies';

export interface LocaleInfo {
  name: string;
  language: string;
  country: string;
  flag: string;
}

@Injectable({
  providedIn: 'root',
})
export class LocaleService {
  public currencies: Currency[] = currencies;
  public showLocaleModal$ = new BehaviorSubject(false);
  public currentLocale = new BehaviorSubject<string>('en');
  public currentCurrency = new ReplaySubject<Currency>();

  public locales: LocaleInfo[] = [
    {
      name: 'en',
      language: 'English',
      country: 'United States',
      flag: 'us',
    },
    {
      name: 'es',
      language: 'Spanish',
      country: 'Spain',
      flag: 'es',
    },
    {
      name: 'it',
      language: 'Italian',
      country: 'Italy',
      flag: 'it',
    },
    {
      name: 'de',
      language: 'German',
      country: 'Germany',
      flag: 'de',
    },
    {
      name: 'fr',
      language: 'French',
      country: 'France',
      flag: 'fr',
    },
    {
      name: 'pt',
      language: 'Portuguese',
      country: 'Portugal',
      flag: 'pt',
    },
  ];

  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
    @Inject(LOCALE_ID) private locale: string
  ) {}

  public init() {
    const currencyCode = this.cookieService.get('hh_currency');

    if (currencyCode) {
      this.currentCurrency.next(
        currencies.find((currency) => currency.code === currencyCode)!
      );
    } else {
      this.currentCurrency.next({
        name: getLocaleCurrencyName(this.locale)!,
        symbol_native: getLocaleCurrencySymbol(this.locale)!,
        code: getLocaleCurrencyCode(this.locale)!,
      });
    }

    const locale = this.cookieService.get('hh_locale');

    if (locale) {
      this.currentLocale.next(locale);
    } else {
      this.currentLocale.next(this.locale);
    }
  }

  public getAvailableCurrencies() {
    return currencies;
  }

  public setCurrency(currency: Currency) {
    this.http
      .post(`${window.location.origin}/api/set-currency`, currency)
      .subscribe((_) => {
        // this.currentCurrency.next(currency);
        window.location.reload();
      });
  }

  public showLocaleModal() {
    this.showLocaleModal$.next(true);
  }

  closeLocaleModal() {
    this.showLocaleModal$.next(false);
  }

  setLocale(lang: string) {
    this.http
      .post(`${window.location.origin}/api/set-locale`, { lang })
      .subscribe();
  }
}
